<template>
  <router-link :class="navLinkClass" :to="link">
    {{ text }}
  </router-link>
</template>

<script>
export default {
  name: 'app-content-nav-link',
  props: {
    link: {
      type: [String, Object],
      required: true
    },
    text: {
      type: String,
      default: 'Odkaz'
    },
    iconSide: {
      type: String,
      default: 'left'
    },
    navLinkClass: {
      type: String,
      default: ''
    }
  }
}
</script>
